// @flow

export const log = (...args: any) => {
  if (window.trackJs) {
    window.trackJs.console.log(...args);
  } else if (window.console && window.console.log) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};
